import { render } from "./ProductGrid.vue?vue&type=template&id=0cda1120"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__